import { render } from "./CommsPreferences.vue?vue&type=template&id=a2c9e2ae"
import script from "./CommsPreferences.vue?vue&type=script&lang=js"
export * from "./CommsPreferences.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__